import { useCallback, useEffect, useMemo, useState } from "react"
import { IAgoraRTCRemoteUser } from "agora-rtc-sdk-ng"
import UserVideoDisplay from "./userVideoDisplay"
import Avatar from "@components/profile/avatar";

interface ISelectedUserVideoDisplayProps {
    username: string,
    selectedUser: string,
    getCurrentUser: (username: string) => IAgoraRTCRemoteUser | undefined,
    selectVideo: (username: string) => void
}

const SelectedUserVideoDisplay = (props: ISelectedUserVideoDisplayProps) => {
    const { username, selectedUser, getCurrentUser, selectVideo } = props

    const [isNoUserTrack, setIsNoUserTrack] = useState<boolean>(false)

    useEffect(() => {
        setIsNoUserTrack(username?.includes("track_"))
    }, [username])

    const getUser = useCallback(() => {
        return getCurrentUser(username)
    }, [username, getCurrentUser])

    const getAvatar = useMemo(() => {
        return (
            <Avatar  
                username={username}
                roleCode="PA"
                size={30}
                editable={false}
            />
        )
    }, [username])

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
        { username === selectedUser ?
            <div className="VideoCall__VideoLayout-Selected">
                {isNoUserTrack ?
                    <span className="VideoCall__MiniInfoNameText">
                        Video selected
                    </span>
                    :
                    getAvatar
                }
            </div>
            :
            <UserVideoDisplay
                user={getUser()}
                username={username}
                size={120}
                key={username}
                roleCode="PA"
                onClick={selectVideo}
                userSelected={selectedUser} />
        }
        </>
    )
}

export default SelectedUserVideoDisplay
